import { FieldExpressionImpl, StringValueExpressionImpl, NumericValueExpressionImpl, AddExpressionImpl, SubtractExpressionImpl, MultiplyExpressionImpl, DivideExpressionImpl, SumExpressionImpl, AbsExpressionImpl, ModExpressionImpl, FloorExpressionImpl, CeilExpressionImpl, ConcatExpressionImpl, StringifyExpressionImpl, ToLowerExpressionImpl, ToUpperExpressionImpl, SubstringExpressionImpl, LengthExpressionImpl, } from './Expression';
export const expressions = {
    field: (fieldPath) => new FieldExpressionImpl(fieldPath),
    stringValue: (value) => new StringValueExpressionImpl(value),
    numericValue: (value) => new NumericValueExpressionImpl(value),
    add: (...expressions) => new AddExpressionImpl(expressions),
    subtract: (first, second) => new SubtractExpressionImpl(first, second),
    multiply: (...expressions) => new MultiplyExpressionImpl(expressions),
    divide: (first, second) => new DivideExpressionImpl(first, second),
    sum: (...expressions) => new SumExpressionImpl(expressions),
    abs: (expression) => new AbsExpressionImpl(expression),
    mod: (first, second) => new ModExpressionImpl(first, second),
    floor: (expression) => new FloorExpressionImpl(expression),
    ceil: (expression) => new CeilExpressionImpl(expression),
    concat: (...expressions) => new ConcatExpressionImpl(expressions),
    stringify: (expression) => new StringifyExpressionImpl(expression),
    toLower: (expression) => new ToLowerExpressionImpl(expression),
    toUpper: (expression) => new ToUpperExpressionImpl(expression),
    substring: (expression, start, length) => new SubstringExpressionImpl(expression, start, length),
    length: (expression) => new LengthExpressionImpl(expression),
};
//# sourceMappingURL=expressions.js.map